import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | null>(null);
  const content = {
    terms: {
      title: 'Términos de Servicio',
      body: <div className="space-y-4 text-warmWhite-200 text-left leading-relaxed" data-id="element-29">
          <p data-id="element-30">Última actualización: {new Date().getFullYear()}</p>
          <p data-id="element-31">
            Al acceder y utilizar El Protocolo de Sueño Profundo, usted acepta
            estar sujeto a estos Términos de Servicio.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-32">1. Uso del Servicio</h3>
          <p data-id="element-33">
            El contenido proporcionado es solo para fines informativos y
            educativos. No sustituye el consejo médico profesional, diagnóstico
            o tratamiento.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-34">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-35">
            Todo el contenido, incluyendo textos, gráficos, audios y documentos
            PDF, está protegido por derechos de autor y es propiedad exclusiva
            de El Protocolo de Sueño Profundo.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-36">
            3. Limitación de Responsabilidad
          </h3>
          <p data-id="element-37">
            No garantizamos resultados específicos, ya que el éxito del
            protocolo depende del compromiso individual y factores biológicos
            personales.
          </p>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      body: <div className="space-y-4 text-warmWhite-200 text-left leading-relaxed" data-id="element-38">
          <p data-id="element-39">Última actualización: {new Date().getFullYear()}</p>
          <p data-id="element-40">
            Su privacidad es importante para nosotros. Esta política explica
            cómo recopilamos, usamos y protegemos su información personal.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-41">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-42">
            Recopilamos información básica necesaria para procesar su compra y
            entregar el producto digital, como su nombre y dirección de correo
            electrónico.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-43">
            2. Uso de la Información
          </h3>
          <p data-id="element-44">
            Utilizamos su información exclusivamente para proporcionarle acceso
            al protocolo, enviarle actualizaciones relevantes y soporte técnico.
          </p>
          <h3 className="text-gold-400 font-bold mt-4" data-id="element-45">
            3. Protección de Datos
          </h3>
          <p data-id="element-46">
            Implementamos medidas de seguridad estándar de la industria para
            proteger su información personal contra acceso no autorizado o
            divulgación.
          </p>
        </div>
    }
  };
  return <>
      <footer className="py-8 text-center text-warmWhite-200/50 text-sm border-t border-white/5" data-id="element-47">
        <div className="flex justify-center gap-6 mb-4" data-id="element-48">
          <button onClick={() => setOpenModal('terms')} className="hover:text-gold-400 transition-colors" data-id="element-49">
            Términos de Servicio
          </button>
          <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-400 transition-colors" data-id="element-50">
            Política de Privacidad
          </button>
        </div>
        <p data-id="element-51">
          © {new Date().getFullYear()} El Protocolo de Sueño Profundo. Todos
          los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-52">
        {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-53">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setOpenModal(null)} className="absolute inset-0 bg-navy-900/80 backdrop-blur-sm" data-id="element-54" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="glass-card relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-6 md:p-8 z-10 shadow-2xl border border-white/10" data-id="element-55">
              <button onClick={() => setOpenModal(null)} className="absolute top-4 right-4 p-2 text-warmWhite-200/50 hover:text-warmWhite-100 transition-colors rounded-full hover:bg-white/5" data-id="element-56">
                <X className="w-5 h-5" data-id="element-57" />
              </button>

              <h2 className="text-2xl font-heading font-bold text-gold-400 mb-6 pr-8" data-id="element-58">
                {content[openModal].title}
              </h2>

              {content[openModal].body}
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}